var cursor = null;

var currentController = null;

$('.mizkan__mizkan-ch__cat__btn').click(function () {
    if (currentController) {
        currentController.abort();
        currentController = null;
    }
    
    if ($(this).hasClass('mizkan__mizkan-ch__cat__all')) {
        $('.mizkan__mizkan-ch__cat__btn').removeClass('mizkan__mizkan-ch__cat__check--active');
        $(this).addClass('mizkan__mizkan-ch__cat__check--active');
    } else {
        $(this).toggleClass('mizkan__mizkan-ch__cat__check--active');
    }
    if ($('.mizkan__mizkan-ch__cat__check--active:not(.mizkan__mizkan-ch__cat__all)').length > 0) {
        $('.mizkan__mizkan-ch__cat__all ').removeClass('mizkan__mizkan-ch__cat__check--active');
    }
    cursor = null;
    $('.mizkan__mizkan-ch__articles-box .mizkan__mizkan-ch__article ').remove();
    loadArticles();
});

$(document).ready(function () {
    loadArticles();
});

document.querySelector('#mizkan__show__more__blogs').addEventListener('click', function (e) {
    loadArticles();
});

async function loadArticles() {
    const loading = $('.comment-loading');
    loading.addClass('is-loading');

    try {
        let tags = [];
        $(".mizkan__mizkan-ch__cat__check--active:not(.mizkan__mizkan-ch__cat__all)").each(function () {
            tags.push($(this).data('tag'));
        });
        
        const controller = new AbortController();
        currentController = controller;
        
        const result = await fetch(`${window.AppProxyPath}/api/customers/mizkan-ch`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                blog_handle: $('#mizkan__show__more__blogs').data('blog-handle'),
                tags: tags,
                cursor: cursor
            }),
            signal: controller.signal
        });
        
        const res = await result.json();
        if (res) {
            if (res.data.length) {
                cursor = res.data[res.data.length - 1].cursor;
                for (const article of res.data) {
                    let new_article;
                    if (article.node.herocontent && article.node.herocontent.value == "true") {
                        new_article = $('.article_template .mizkan__mizkan-ch__article--big').clone();
                    } else {
                        new_article = $('.article_template .mizkan__mizkan-ch__article:not(.mizkan__mizkan-ch__article--big)').clone();
                    }
                    $('.mizkan__mizkan-ch__cat-box .mizkan__mizkan-ch__cat', new_article).remove();
                    $('.mizkan__mizkan-ch__title', new_article).text('');
                    if (article.node.image) {
                        $('.mizkan__mizkan-ch__article__img img', new_article).attr('src', article.node.image.url);
                        // alt属性にブログのタイトルを設定
                        $('.mizkan__mizkan-ch__article__img img', new_article).attr('alt', article.node.title);
                    }
                    $('.mizkan__news__date', new_article).text('');
                    $('.mizkan__mizkan-ch__content__sp', new_article).text('');
                    $('.mizkan__mizkan-ch__content__pc', new_article).text('');
                    $('.mizkan__mizkan-ch__article__tag', new_article).remove('');
                    article.node.tags.forEach(function (tag) {
                        if (tag === "レパつく投稿" || tag === '会員登録必須' || tag === 'コピーガード' || tag === '公開NG' || tag.startsWith('ミツカンchアンケート') || tag === 'コメントなし' || tag === 'noindex') {
                            return;
                        }
                        if (!tag.includes("#")) {
                            if (tag.includes("イベント")) {
                                tag += "・体験";
                            }
                            $('.mizkan__mizkan-ch__cat-box', new_article).append('<span class="mizkan__mizkan-ch__cat">' + tag + '</span>');
                        } else if (tag.includes("#")) {
                            $('.mizkan__mizkan-ch__hastag-box', new_article).append('<p class="mizkan__mizkan-ch__article__tag">' + tag + '</p>');
                        }
                    });
                    $('.mizkan__mizkan-ch__title', new_article).text(ellipsis(article.node.title, 23));
                    if (article.node.image) {
                        $('.mizkan__mizkan-ch__article__img img', new_article).attr('src', article.node.image.url);
                    }
                    $('.mizkan__news__date', new_article).text(formatDate(article.node.publishedAt) + ' UPDATE');
                    $('.mizkan__mizkan-ch__content__sp', new_article).text(ellipsis(article.node.content, 22));
                    $('.mizkan__mizkan-ch__content__pc', new_article).text(ellipsis(article.node.content, 60));
                    new_article.attr('href', article.node.onlineStoreUrl);

                    // コメントデータの取得
                    let firstActiveCommentObject = null;
                    let commentNumber = 0;

                    // コメント数を取得（コメントがない場合は0）
                    commentNumber = article.node.comments?.totalCount || 0;

                    if (article.node.comments?.latestComment) {
                        firstActiveCommentObject = {
                            author: {
                                nickname: article.node.comments.latestComment.author.name,
                                usericon: article.node.comments.latestComment.author.icon_url
                            },
                            content: article.node.comments.latestComment.content
                        };
                    }

                    // ヒーローコンテンツの場合はコメントを表示
                    if (article.node.herocontent && article.node.herocontent.value == "true") {
                        if (firstActiveCommentObject) {
                            const commentItem = createCommentItem(firstActiveCommentObject, commentNumber);
                            new_article.append(commentItem);
                            new_article.find('.mizkan__mizkan-ch__article__info').addClass('has-comment');
                        }
                    }

                    // ヒーローコンテンツ以外の記事にコメント数を表示
                    if (!(article.node.herocontent && article.node.herocontent.value == "true")) {
                        const count = document.createElement('div');
                        count.classList.add('count');
                        const countIcon = document.createElement('img');
                        countIcon.src = 'https://cdn.shopify.com/s/files/1/0790/7003/6254/files/fukidashi_web.png?v=1740022502';
                        const commentCount = document.createElement('span');
                        if (commentNumber > 0 && commentNumber < 10000) {
                            commentCount.textContent = commentNumber;
                        } else if (commentNumber >= 10000) {
                            commentCount.textContent = '9999+';
                        } else {
                            commentCount.textContent = '0';  // 0件の場合も表示
                        }
                        count.appendChild(countIcon);
                        count.appendChild(commentCount);
                        $('.mizkan__mizkan-ch__cat-box', new_article).append(count);
                    }

                    $('.mizkan__mizkan-ch__articles-box').append(new_article.removeAttr('hidden'));

                    new_article.find('.badge--new')
                        .addClass('mizkan-ch-content-new-icon')
                        .attr({
                            'data-id': article.node.id.replace('gid://shopify/Article/', ''),
                            'data-published_at': article.node.publishedAt,
                            'hidden': true  // 初期状態は非表示に設定
                        });

                    // 記事追加完了後にNEWアイコンの表示をチェック
                    const unReadContentsObj = JSON.parse(localStorage.getItem('unReadContents'));
                    if (unReadContentsObj) {
                        // DOMの更新を待ってからチェック実行
                        setTimeout(() => {
                            checkNewMizkanChContents(unReadContentsObj);
                        }, 0);
                    }
                }
            }
            if (res.hasNextPage) {
                $('#mizkan__show__more__blogs').removeClass('disabled').removeAttr('hidden');
            } else {
                $('#mizkan__show__more__blogs').attr('hidden', true);
            }
            typeSquareTargetBody();
        }
    } catch (error) {
        if (error.name !== 'AbortError') {
            console.error('Failed to load articles:', error);
        }
    } finally {
        loading.removeClass('is-loading');
        if (currentController === controller) {
            currentController = null;
        }
    }
}

function createCommentItem(comment_data, commentNumber) {
    const commentItem = document.createElement('div');
    commentItem.classList.add('mizkan__top__main__comment-item');

    const authorIcon = document.createElement('img');
    // ドメインに基づいて異なるアイコンURLを設定
    let defaultIconUrl;
    if (window.location.hostname === '365.mizkan.co.jp') {
        defaultIconUrl = '//365.mizkan.co.jp/cdn/shop/files/user_icon_1.png';
    } else {
        defaultIconUrl = '//dev-365.myshopify.com/cdn/shop/files/user_icon_1.png';
    }
    authorIcon.classList.add('author-icon');
    const authorIconUrl = comment_data.author.usericon || defaultIconUrl;
    authorIcon.src = authorIconUrl;
    authorIcon.alt = comment_data.author.nickname + "のアイコン";
    commentItem.appendChild(authorIcon);

    const textBox = document.createElement('div');
    textBox.classList.add('mizkan__top__main__comment__text-box');
    commentItem.appendChild(textBox);

    const nameCountBox = document.createElement('div');
    nameCountBox.classList.add('name-count-box');
    const name = document.createElement('span');
    name.classList.add('name');
    name.textContent = comment_data.author.nickname;
    nameCountBox.appendChild(name);
    
    const count = document.createElement('div');
    count.classList.add('count');
    const countIcon = document.createElement('img');
    countIcon.src = 'https://cdn.shopify.com/s/files/1/0790/7003/6254/files/fukidashi_web.png?v=1740022502';
    const commentCount = document.createElement('span');
    if (commentNumber > 0 && commentNumber < 10000) {
        commentCount.textContent = commentNumber;
    } else {
        commentCount.textContent = '9999+';
    }
    count.appendChild(countIcon);
    count.appendChild(commentCount);
    nameCountBox.appendChild(count);
    textBox.appendChild(nameCountBox);

    const commentContent = document.createElement('p');
    commentContent.classList.add('comment-content');
    commentContent.textContent = comment_data.content;
    textBox.appendChild(commentContent);

    return commentItem;
}

function ellipsis(str, len) {
    return str.length > len ? str.substring(0, len) + '...' : str;
}

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('.');
}


// チュートリアル
document.addEventListener("DOMContentLoaded", function () {
    const mizkanChModal = document.querySelector('.mizkan-ch_modal');
    const mizkanChCloseBtn = mizkanChModal.querySelector('.btn_gray')
    const mizkanChModalClosed = localStorage.getItem('mizkanChModalClosed');
    const currentPath = window.location.pathname;

    // 初回訪問時にモーダルを表示しないように変更（if文の条件をfalseに）
    if (false && currentPath === '/blogs/mizkan-ch' && !mizkanChModalClosed) {
        mizkanChModal.classList.add('active');
    }

    if (mizkanChCloseBtn) {
        mizkanChCloseBtn.addEventListener('click', function () {
            mizkanChModal.classList.remove('active');
            localStorage.setItem('mizkanChModalClosed', 'true');
        })
    }
})